var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VueHorizontalList',{attrs:{"items":_vm.cobs,"options":{
    responsive: [
      { end: 576, size: 1 },
      { start: 576, end: 768, size: 2 },
      { size: 3 } ],
  }},scopedSlots:_vm._u([{key:"default",fn:function(ref){
  var item = ref.item;
return [_c('div',{staticClass:"item"},[_c('Card',{staticClass:"animate__animated animate__fadeInUp",attrs:{"data":item,"title":item.DESCRIPCIONCOBERTURA,"desc":item.DESCRIP,"name":item.NOMENCLATURA,"deducible":item.DEDUCIBLES.length > 0 ? item.DEDUCIBLES[0].VALOR : 0,"suma":item.SUMAS.length > 0 ? item.SUMAS[0].VALOR : 0,"cost":item.PRIMA === 0 ? item.PRIMA.toString() : _vm.formatMoney(item.PRIMA),"radio":item.check,"orden":item.ORDEN,"updateSuma":_vm.updateSumaCobertura,"prima":item.PRIMA}})],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }